import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CircularProgressLoading from "../../../components/Accessibility/CircularProgressLoading";
import { RetornaAceiteTermoResponse } from "../../../interfaces/entities/RetornaAceiteTermoResponse";
import { BoasVindas } from "../../../interfaces/entities/UnimedAcolhe/BoasVindas";
import { UnimedAcolheMenu } from "../../../interfaces/entities/UnimedAcolhe/UnimedAcolheMenu";
import { aceiteNaoMostrarNovamente, getMostrarNovamenteBoasVindas } from "../../../services/SaudeBemEstar/SaudeEmocionalService";
import { getBoasVindas, getMenusSaudeEmocional } from "../../../services/SaudeBemEstar/UnimeAcolheService";
import { getBenef } from "../../../Store/storages/BeneficiarioStorage";
import BoasVindasComponent from "./BoasVindas";
import { defaultWelcome } from "./defaultStates";
import UnimedAcolheOptions from "./UnimedAcolheOptions";
import AudioLoadingDescription from "../../../components/Accessibility/AudioLoadingDescription";

function UnimedAcolhe() {
    const benef = getBenef();
    const [loading, setLoading] = useState<boolean>(false);
    const [welcome, setWelcome] = useState<BoasVindas>(defaultWelcome);
    const [showWelcome, setShowWelcome] = useState<boolean>(true);
    const [acceptTerms, setAcceptTerms] = useState<RetornaAceiteTermoResponse | null>(null);
    const [menus, setMenus] = useState<UnimedAcolheMenu[]>([]);
    const location = useLocation();

    useEffect(() => {
        Promise.all([
            getBoasVindas(),
            getMenusSaudeEmocional(),
            getMostrarNovamenteBoasVindas()
        ]).then(results => {
            if (results[0] !== null && results[1] !== null && results[2] !== null) {
                if (results[2].indAceite === 'N' && !location.pathname.includes("inicio")) {
                    setShowWelcome(true);
                }
                else {
                    setShowWelcome(false);
                }
                setAcceptTerms(results[2]);
                setWelcome(results[0])
                setMenus(results[1])
                setLoading(false);
            }
        })

        if (location.pathname.includes("inicio")) {
            setShowWelcome(false);
        }
        setLoading(true);
    }, []);

    const handleWelcome = async (checked: boolean) => {
        if (acceptTerms !== null && checked) {
            await aceiteNaoMostrarNovamente(acceptTerms.idTermoResponsabilidade, acceptTerms.idOperador)
        }
        setShowWelcome(false);
    }

    return (
        <div className="unimed-acolhe-holder">
            <AudioLoadingDescription loading={loading}/>
            {loading &&
                <div className="loading-holder">
                    <CircularProgressLoading />
                </div>
            }
            {!loading && showWelcome &&
                <BoasVindasComponent text={welcome.textos[0]} benef={benef?.nome || ''} handleWelcome={handleWelcome} />
            }
            {!loading && !showWelcome &&
                <UnimedAcolheOptions image={welcome.imagens[0]} menus={menus} />
            }
        </div>
    )
}

export default UnimedAcolhe;